"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fail = exports.Pass = void 0;
function Pass(value) {
    return { Success: true, Value: value };
}
exports.Pass = Pass;
function Fail(error) {
    return { Success: false, Error: error };
}
exports.Fail = Fail;
//# sourceMappingURL=result.js.map